<template>
    <AppSection :title="params.title">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <div v-html="params.header_right"></div>
        </template>
        <template #body>
            <div class="container">
                <div class="row">
                    <icon-card v-for="(item, i) in params.items" :key="i" v-bind="item" class="col d3 md-6 sm-12"/>
                </div>
            </div>
        </template>
    </AppSection>
</template>

<script>
import AppSection from '../AppSection.vue'
import IconCard from '../cards/IconCard.vue'

export default {
    name: 'IconCardsSection',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        AppSection,
        IconCard,
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    
</style>
